/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { IAny } from '../DashboardKPIWidgets/IEnergyManagementProps';
import { formatCurrency, getSymbolFromCurrency } from '../shared/Utils/Utils';
import moment from 'moment';
import _ from 'lodash';
import { Loader } from '@scuf/common';
import { useTranslation } from '@scuf/localization';

interface BillDetail {
  date: string;
  cost: string;
}

interface BillMonthYearDetailViewProps {
  data: BillDetail[];
  onBillClick: (payload: IAny) => void;
}
const addnew: IAny = {
  siteId: '',
  logicalAccountId: '',
  accountId: '',
  accountNumber: '',
  statementId: '',
  totalBillAmount: 0,
  intervalStartDate: '',
  intervalEndDate: 'New Bill',
  dataSource: ''
};

export const BillMonthYearDetailView = (props: IAny) => {
  const [t, lng] = useTranslation();
  const {
    data,
    isNewBill,
    utilityCellData,
    isPDFExtracted,
    isMultipleUploaded,
    billDetails
  } = props;
  const [monthData, setMonthData] = useState(data);
  const [yearData, setYearData] = useState<IAny>();
  const [getAllYearList, setAllYearList] = useState<IAny>();
  const [active, setActive] = useState();
  const currentYear = new Date().getFullYear().toString();
  useEffect(() => {
    if (isNewBill) {
      if (yearData && yearData.length) {
        let temMonthData = JSON.parse(JSON.stringify(yearData));
        Object.keys(temMonthData[0]).forEach((elem) => {
          const ind = temMonthData[0][elem].findIndex((el: IAny) => {
            return el.intervalEndDate === 'New Bill';
          });
          if (ind !== -1) {
            temMonthData[0][elem].splice(ind, 1);
          }
          temMonthData[0][elem].splice(0, 0, addnew);
        });
        setYearData(temMonthData);
      } else {
        let arrNew: IAny = [];
        let tempMonthData: IAny = {};
        tempMonthData[currentYear] = [addnew];
        arrNew.push(tempMonthData);
        setYearData(arrNew);
      }
    }
  }, [isNewBill]);

  const newData = () => {
    let newArr: IAny = {};
    getAllYearList.forEach((ele: IAny) => {
      monthData.forEach((item: IAny) => {
        let dateStr = moment(item.intervalEndDate, 'MMM DD YYYY hh:mma')
          .year()
          .toString();
        if (dateStr === ele) {
          if (newArr[ele] && newArr[ele].length) {
            return newArr[ele].push(item);
          } else {
            return (newArr[ele] = [item]);
          }
        }
      });
    });
    let allSorted: IAny = Object.keys(newArr).sort(function(a: IAny, b: IAny) {
      return b - a;
    });
    const sortedData: IAny = [];
    for (let i = 0; i < allSorted.length; i++) {
      let obj: IAny = {};
      obj[allSorted[i]] = newArr[allSorted[i]];
      sortedData.push(obj);
    }
    return setYearData(sortMonthData(sortedData));
  };

  const sortMonthData = (data: IAny) => {
    data.forEach((item: IAny) => {
      Object.keys(item).map((ele) => {
        item[ele].sort(function(a: any, b: IAny) {
          return (
            (moment(b.intervalEndDate, 'MMM DD YYYY hh:mma').format(
              'MM'
            ) as IAny) -
            (moment(a.intervalEndDate, 'MMM DD YYYY hh:mma').format(
              'MM'
            ) as IAny)
          );
        });
      });
    });
    return data;
  };

  useEffect(() => {
    setMonthData(data);
  }, [data]);

  useEffect(() => {
    if (monthData && monthData.length) {
      getUniqueYears();
    }
  }, [monthData]);

  useEffect(() => {
    if (getAllYearList && getAllYearList.length) {
      newData();
    }
  }, [getAllYearList]);

  useEffect(() => {
    if (yearData && yearData.length) {
      const firstYr = yearData[0];
      const obj: IAny = {};
      Object.keys(firstYr).forEach((yr) => {
        obj.logicalAccountId = firstYr[yr][0].logicalAccountId;
        obj.accountId = firstYr[yr][0].accountId;
        !isMultipleUploaded && setActive(firstYr[yr][0]);
      });
      if (!isNewBill && !isMultipleUploaded) {
        props.onBillClick(obj);
      }
    }
  }, [yearData]);

  const dateFormat = (dateString: IAny) => {
    const dateParts = moment(dateString, 'MMM DD YYYY hh:mma')
      .locale(lng)
      .format('MMM, YYYY');
    return dateParts;
  };

  const parseYearFromCustomFormat = (dateString: string): string => {
    let fullYear = moment(dateString, 'MMM DD YYYY hh:mma')
      .year()
      .toString();
    if (fullYear) {
      return fullYear;
    }
    return '';
  };

  const getUniqueYears = (): IAny => {
    const yearsSet = new Set<string>();
    monthData.forEach((item: IAny) => {
      const year = parseYearFromCustomFormat(item.intervalEndDate);
      if (year) {
        yearsSet.add(year);
      }
    });
    let sortedYear = Array.from(yearsSet).sort(function(a: IAny, b: IAny) {
      return b - a;
    });
    return setAllYearList(sortedYear);
  };

  const handleManageBill = (ele: IAny) => {
    setActive(ele);
    props.onBillClick({
      logicalAccountId: ele.logicalAccountId,
      accountId: ele.accountId
    });
  };
  return (
    <div>
      <div className="bill-details">
        <ul>
          {yearData &&
            yearData.map((item: IAny, key: IAny) => {
              return (
                <div className="bill-detail-li">
                  {Object.keys(item).map((element: IAny, index: number) => {
                    return (
                      <div>
                        <span className="year-head">
                          {element === currentYear ? 'CURRENT YEAR' : element}
                        </span>
                        {item[element].map((ele: IAny) => {
                          return (
                            <React.Fragment>
                              <li
                                key={index}
                                className={active === ele ? 'active-li' : ''}
                                onClick={() => handleManageBill(ele)}
                                style={
                                  isNewBill || isPDFExtracted
                                    ? { pointerEvents: 'none' }
                                    : { cursor: 'pointer' }
                                }
                              >
                                <span>
                                  {ele.intervalEndDate === 'New Bill'
                                    ? ele.intervalEndDate
                                    : dateFormat(ele.intervalEndDate)}
                                </span>
                                <span className="amount-field">{`${utilityCellData &&
                                  // getSymbolFromCurrency
                                  formatCurrency(
                                    ele.totalBillAmount,
                                    utilityCellData &&
                                      utilityCellData.integrationType ===
                                        'Automatic'
                                      ? billDetails && billDetails.currencyUnit
                                      : utilityCellData.currencyUnit,
                                    false,
                                    2
                                  )}`}</span>
                                {/* ${ele.totalBillAmount} */}
                              </li>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </ul>
        {isMultipleUploaded && (
          <div style={{ position: 'relative' }}>
            <Loader overlayColor="#a0a0a0">
              <div className="placeholder" />
            </Loader>
          </div>
        )}
      </div>
    </div>
  );
};
